import React from 'react';
import { defaultDropAnimationSideEffects } from '@dnd-kit/core';
import { TaskItem } from '../../../../types/topic';
import { TaskCard } from '../TaskCard';

interface UseDragOverlayProps {
  activeTaskId: string | null;
  activeTask: TaskItem | undefined;
}

/**
 * Hook for drag overlay configuration and rendering
 */
export function useDragOverlay({ activeTaskId, activeTask }: UseDragOverlayProps) {
  // Configuration for the drag overlay animation
  const dropAnimation = {
    duration: 0,
    easing: 'ease',
    keyframes() {
      return [{ transform: 'translate3d(0, 0, 0)' }];
    },
    sideEffects: defaultDropAnimationSideEffects({
      styles: {
        active: {
          opacity: '0.2',
        },
      },
    }),
  };

  // Render function for the overlay content
  const renderOverlay = () => {
    if (!activeTaskId || !activeTask) return null;

    return (
      <div
        className="w-[calc(100%-48px)] max-w-sm"
        style={{
          cursor: 'grabbing',
          boxShadow:
            '0 12px 25px -5px rgba(0, 0, 0, 0.2), 0 8px 15px -6px rgba(0, 0, 0, 0.1)',
        }}
      >
        <TaskCard
          task={activeTask}
          index={0}
          isFirst={false}
          isLast={false}
          onDelete={() => {}}
          onDeleteClick={() => {}}
          onCancelDelete={() => {}}
          onUpdateTask={() => {}}
          itemToDelete={null}
          customDragHandlers={true}
        />
      </div>
    );
  };

  return {
    dropAnimation,
    renderOverlay,
  };
}